/**
 * displays password errors
 * 
 * @param {Object} validationErrors 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const PasswordValidationErrors = ({validationErrors}) => {


    if(validationErrors.password && validationErrors.password.length === 1){
        return(
            <p className="text-sm text-red-500 italic">Password must {validationErrors.password[0]}</p>

        )
    } else if(validationErrors.password && validationErrors.password.length > 1){
        return (
            <>
                <p className="text-sm text-red-500 italic">Password must:</p>
                {validationErrors.password.map(error => (
                    <li className="text-sm text-red-500 italic ml-4">{error}</li>
                ))}
            </>
        )
    } else {
        return null
    }
}
